import { authorization } from "./store/AuthorizationState";
import { useInterval } from "./hooks/useInterval";
import { useUnauthorizedError } from "./store/UnauthorizedErrorState";
import UnauthorizedError from "./UnauthorizedError";

const AuthorizationObserver = () => {
  const { throwUnauthorizedError } = useUnauthorizedError();

  //認証チェックポーリング
  useInterval(async () => {
    try {
      await authorization();
    } catch (e) {
      if (e instanceof UnauthorizedError) {
        throwUnauthorizedError(e);
      } else {
        throw e;
      }
    }
  }, 24 * 60 * 60 * 1000); //1日に1回

  return null;
};

export default AuthorizationObserver;
